import {Injectable} from '@angular/core';

import {
  ActivatedRouteSnapshot
} from "@angular/router";
import {Subject} from "rxjs";
import {GlobalQuestionService} from "../../../../../swaggerServices";
import {IQuestionWithScAndSg} from "./question/global-question.component";

@Injectable()
export class GlobalQuestionsResolver  {

  question: any;
  $question: Subject<IQuestionWithScAndSg> = new Subject<IQuestionWithScAndSg>();

  constructor(private questionService: GlobalQuestionService) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const isNewQuestion = route.paramMap.get('id') === "new";

    if (isNewQuestion) {
      const question: IQuestionWithScAndSg = {
        id: 0,
        question: null,
        mandatory: false,
        default: null,
        min: null,
        max: null,
        maxLength: null,
        hint: null,
        APSRef: null,
        APSSection: null,
        APSSubsection: null,
        APSQuestionGrouping: null,
        APSDimension: null,
        isCurrency: false,
        isPercentage: false,
        displayFieldType: 'text',
        dataType: 'string',
        dependantMandatoryParentId: null,
        dependantMandatoryParentValue: null,
        questionDropdowns: [],
      };
      this.question = question;
      this.overrideYearAndTaxReturnTypeId();
      setTimeout(() => this.$question.next(this.question))

    } else {
      const id = Number(route.paramMap.get('id'));
      return this.fetch(id);
    }

  }

  overrideYearAndTaxReturnTypeId() {
    if (this.question) {
      this.question.year = 1900; // this is a hardcoded value for globalQuestion
      this.question.taxReturnTypeId = null;
    }
  }

  getQuestionsObs() {
    return this.$question;
  }

  private fetch(id: number) {
    return this.questionService.getglobalQuestionById(id).subscribe(data => {
      this.question = data;
      this.overrideYearAndTaxReturnTypeId();
      this.$question.next(this.question);
      return data;
    });

  }

}
